module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-08-18 at 11.54.58.0997ef8b.png";